import { Model } from 'backbone';
import constants from 'Constants.js';
import pageCollection from 'PageCollection.js';
class FormModel extends Model {

    initialize() {

    	this.set({
    		currentDevice: 'deviceDesktop'
    	});


        this.initDevice = {
            formHeight: 400,
            formWidth: 500
        }

        this.initDeviceTablet = {
            formHeight: constants.TABLET_MAX_HEIGHT,
            formWidth: constants.TABLET_MAX_WIDTH,
            errorList: []
        }

        this.initDevicePhone = {
            formHeight: constants.PHONE_MAX_HEIGHT,
            formWidth: constants.PHONE_MAX_WIDTH,
            errorList: []
        }

        this.set({
            deviceDesktop: this.initDevice,
            deviceTablet: this.initDeviceTablet,
            devicePhone: this.initDevicePhone

        });

        /*
        var form = this;
        this.on('change:currentDevice', function(){

            // hitting attributes directly instead of using getter to
            // access dynamic currentDevice value
            form.set( this.attributes[this.attributes.currentDevice], {silent:true} );
        });
*/

    }

    defaults() {
        return {};
    }

}

const formModel = new FormModel();
export default formModel;

